import React from 'react';
import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// The chart's notes (what is not drawn, and why; what a layer must be read with) as ONE small marker in the
// plot's bottom-left corner, with the notes in its tooltip — not a text column over the chart's controls.
// Amber when a line is flagged `failed` by its source (a read that did not load), never by its wording.
// A tap opens it at once on touch screens (no long press), and it stays up long enough to read.
const ChartStatusInfo = ({ lines }) => {
  if (!lines?.length) return null;
  const failed = lines.some((line) => line.failed === true);
  return (
    <Tooltip
      placement="top-start"
      arrow
      enterTouchDelay={0}
      leaveTouchDelay={15000}
      title={(
        <Box component="ul" sx={{ m: 0, pl: 2, fontSize: '0.75rem', lineHeight: 1.4 }}>
          {lines.map((line) => <li key={line.id} data-testid={line.id}>{line.text}</li>)}
        </Box>
      )}
    >
      <Box
        component="button"
        type="button"
        aria-label={`Chart notes (${lines.length})`}
        data-testid="chart-status-info"
        data-failed={failed ? 'true' : 'false'}
        sx={{
          position: 'absolute',
          bottom: 36,
          left: 8,
          zIndex: 10,
          display: 'flex',
          alignItems: 'center',
          gap: 0.25,
          p: 0.25,
          border: 'none',
          borderRadius: 1,
          cursor: 'help',
          bgcolor: 'background.paper',
          opacity: 0.85,
          color: failed ? 'warning.main' : 'text.secondary',
          fontSize: '0.7rem',
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 16 }} />
        {lines.length > 1 && <span>{lines.length}</span>}
      </Box>
    </Tooltip>
  );
};

ChartStatusInfo.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired, text: PropTypes.string.isRequired, failed: PropTypes.bool,
  })),
};

export default ChartStatusInfo;
